import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { FC, FormEvent, useState } from 'react';

export interface IFeedbackFormView {
  onHandleCancel: () => void;
  onHandleSendFeedback: (text: string) => void;
}

export const FeedbackFormView: FC<IFeedbackFormView> = ({ onHandleCancel, onHandleSendFeedback }) => {
  const { t } = useTranslation();

  const [text, setText] = useState<string>('');

  const onHandleUserInput = (event: FormEvent<HTMLTextAreaElement>) => {
    setText(event.currentTarget.value);
  };

  const onHandleSubmit = () => {
    onHandleSendFeedback(text.trim());
  };

  return (
    <div>
      <p>{t('FeedbackDialog.Form.Description')}</p>
      <textarea name="feedback" onChange={onHandleUserInput} value={text} cols={65} rows={5} />
      <div className="form-buttons-conatainer">
        <Button
          className="submit-btn"
          label={t('FeedbackDialog.Form.SubmitBtn')}
          color={EButtonColor.blue}
          onClick={onHandleSubmit}
          disabled={!text.trim()}
        />
        <Button label={t('FeedbackDialog.Form.CancelBtn')} color={EButtonColor.white} onClick={onHandleCancel} />
      </div>
    </div>
  );
};
